import { useState } from 'react';
import { generateInviteToken, generateInviteURL } from '../lib/invites';
import { useAuthState } from '../hooks/useAuthState';
import '../styles/InviteButton.css';

const InviteButton = ({ targetKind, targetId, onInviteGenerated }) => {
  const { user } = useAuthState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [inviteURL, setInviteURL] = useState('');
  const [showModal, setShowModal] = useState(false);

  const generateInvite = async () => {
    if (!user) return;

    setLoading(true);
    setError('');

    try {
      const token = await generateInviteToken(
        {
          kind: targetKind,
          id: targetId,
        },
        user.uid,
        {
          oneTime: false, // Allow multiple uses for now
          expiresIn: 7 * 24 * 60 * 60, // 7 days
        }
      );

      const url = generateInviteURL(token);
      setInviteURL(url);
      setShowModal(true);

      if (onInviteGenerated) {
        onInviteGenerated(url);
      }
    } catch (err) {
      setError(err.message || 'Failed to generate invite');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(inviteURL);
      alert('Invite link copied to clipboard!');
    } catch (err) {
      setError('Failed to copy to clipboard');
    }
  };

  return (
    <>
      <button
        className="btn btn-primary"
        onClick={generateInvite}
        disabled={loading}
      >
        {loading ? 'Generating...' : 'Generate Invite Link'}
      </button>

      {error && <div className="error-message">{error}</div>}

      {showModal && inviteURL && (
        <div className="invite-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="invite-modal" onClick={(e) => e.stopPropagation()}>
            <div className="invite-modal-header">
              <h3>Invite Link Generated</h3>
              <button
                className="close-button"
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>
            <div className="invite-modal-content">
              <p>Share this link to invite others:</p>
              <div className="invite-url-display">
                <input
                  type="text"
                  readOnly
                  value={inviteURL}
                  className="invite-url-input"
                />
                <button className="btn btn-secondary" onClick={copyToClipboard}>
                  Copy
                </button>
              </div>
              <p className="invite-hint">
                This link will expire in 7 days. Share via SMS, email, or social media.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InviteButton;




